import React from 'react';
import { format } from 'date-fns';
import type { EmployeeAwardGrant } from '../../types';
import './AchievementTrophyCard.css';

interface AchievementTrophyCardProps {
  grant: EmployeeAwardGrant;
}

const AchievementTrophyCard: React.FC<AchievementTrophyCardProps> = ({ grant }) => {
  return (
    <article className="ach-trophy-card">
      <div className="ach-trophy-card-icon-wrap">
        <img src={grant.iconUrl} alt="" className="ach-trophy-card-icon" />
      </div>
      <div className="ach-trophy-card-body">
        <h3 className="ach-trophy-card-name">{grant.awardName}</h3>
        <p className="ach-trophy-card-desc">{grant.awardDescription}</p>
        {grant.grantNote ? <p className="ach-trophy-card-note">"{grant.grantNote}"</p> : null}
        <p className="ach-trophy-card-date">Awarded {format(grant.grantedAt, 'MMMM d, yyyy')}</p>
      </div>
    </article>
  );
};

export default AchievementTrophyCard;
